<script context="module" lang="ts">
	import Section from '$lib/components/layout/Section.svelte';
	import Media from '$lib/components/media/Media.svelte';
	import type { SectionConfig } from '$lib/util/pagebuilder';
	import { gql } from 'graphql-request';

	export const config: SectionConfig = {
		collection: 'section_subscription_slider',
		availableFor: ['pages'],
		query: gql`
			id
			link {
				...Link
			}
			translations {
				languages_code {
						code
				}
				title
				subtitle
			}
		`
	};
	type Props = {
		subtilte: string;
		title: string;
		link: any;
		id: number;
	};
</script>

<script lang="ts">
	import Wysiwyg from '$lib/components/inputs/WYSIWYG.svelte';
	import Slider from '$lib/components/util/Slider.svelte';
	import DirectusLink from '$lib/components/navigation/DirectusLink.svelte';
	import Button from '$lib/components/util/Button.svelte';
	import TextWithIcon from '$lib/components/util/TextWithIcon.svelte';
	import { addToCart, getSubscriptionData } from '$lib/stores/shopStore';
	import { onMount } from 'svelte';
	import { page } from '$app/stores';
	import FullWidthSlider from '$lib/components/util/FullWidthSlider.svelte';
	import SubscriptionCardSlider from '$lib/components/ecom/SubscriptionCardSlider.svelte';

	export let data: Props; // the components gets all data via this prop (additionally each top level prop is directly provided to the component)

	let sellingPlans: any[] = [];
	let subscriptionProducts: any[] = [];

	let selectedProductIdx = -1;
	let selectedVariantIdx = -1;
	let selectedSellingPlanIdx = -1;

	const swiperOptions: SwiperOptions = {
		loop: false,
		centeredSlides: false,
		initialSlide: 0
	};

	onMount(async () => {
		const subData = await getSubscriptionData($page.data.location, $page.params.lang);

		sellingPlans = subData.sellingPlans;
		subscriptionProducts = subData.subscriptionProducts;
	});

	function previewImage() {
		const product = subscriptionProducts[selectedProductIdx];
		if (!product.variants.edges[selectedVariantIdx]?.image?.url) {
			return product && product.media && product.media.edges.length > 0
				? product.media.edges[0].node.previewImage.url
				: '';
		}

		return product.variants.edges[selectedVariantIdx]?.image?.url;
	}
</script>

<div class="section-subscription-slider">
	<Section gapType="padding">
		<div class="section-wrapper">
			{#if data.subtitle}
				<div class="subtitle">{data.subtitle}</div>
			{/if}
			<div class="row">
				{#if data.title}
					<div class="title">{data.title}</div>
				{/if}
				{#if data.link}
					<div class="shop-link">
						<DirectusLink {...data.link}>
							<TextWithIcon {...data.link} />
						</DirectusLink>
					</div>
				{/if}
			</div>
			<FullWidthSlider
				name="product-slider-{data.id}"
				type="multi"
				pagination={false}
				navigation={true}
				options={swiperOptions}
				arrowType="arrow"
				slidesPerView={1.1}
				slidesPerViewPhone={2}
				slidesPerViewTablet={2}
				slidesPerViewDesktopSmall={3}
				slidesPerViewDesktop={4}
			>
				{#each subscriptionProducts ?? [] as product, idx}
					{#key product?.id}
						{#if product}
							<div class="swiper-slide" in:fadein out:fadeout>
								<SubscriptionCardSlider {product} {sellingPlans} />
							</div>
						{/if}
					{/key}
				{/each}
			</FullWidthSlider>
		</div>
	</Section>
</div>

<style lang="scss">
	.subtitle {
		@include font(h6);
		margin-bottom: 8px;
	}
	.title {
		@include font(h3);
		@include media(tablet) {
			max-width: 15ch;
		}
	}
	.row {
		display: flex;
		gap: v(content-padding);
		align-items: flex-end;

		@include media(phone) {
			margin-bottom: v(content-padding);
		}
	}

	@include media(phone) {
		.section-wrapper {
			:global(.swiper-wrapper) {
				margin-inline-start: -16px !important;
			}
		}
	}
	.shop-link {
		white-space: nowrap;
	}
</style>
